window.addEventListener("unhandledrejection", event => {
    if (event.reason && event.reason.name === "ChunkLoadError") {
        event.preventDefault();

        // 새로고침
        setTimeout(() => {
                window.location.reload();
        }, 100);
    }
});

import Vue from "vue";
import VueRouter from "vue-router";
import App from "@/App.vue";
import logger from "@/script/logger";
import utils from "@/script/utils";
import auth from "@/script/auth";
import comApplicant from "@/script/comApplicant";

import axios from "axios";
import "@/assets/css/reset.css";
import "@/assets/css/common.css";
import "@/assets/css/font.css";
import "@/assets/css/icon.css";
import "@/assets/css/applicant.css";
import "@/assets/css/popup.css";

/*Validation*/
import VeeValidator from "vee-validate";

if (process.env.NODE_ENV === "production") {
    // 전역변수로 선언
    console.log = function() {
    };
    console.warn = function() {
    };
    console.error = function() {
    };
    console.info = function() {
    };
    console.debug = function() {
    };
}

Vue.use(VeeValidator);

Vue.config.productionTip = false;

document.title = "KDIS Application for admission";

Vue.use(VueRouter);

// NavigationDuplicated 대응
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => {
        console.log(err);
        console.log(err.name);
        if (err.name !== "NavigationDuplicated") {
            throw err;
        }
    });
};

window.addEventListener('unhandledrejection', function(event) {
    console.error('Unhandled promise rejection:', event.reason);
    console.trace();
});

Vue.prototype.authRoutes = [
    {
        path: "/applicant",
        roleCd: ["ROLE_APPLICANT"],
    },
];

let router;

axios.interceptors.response.use(
    response => {
        if (response.request.statusText != "OK" && response.request.responseURL.endsWith("/login")) {
            alert("You have lost connection to the server.\nPlease log in again.");
            sessionStorage.clear();
            window.open("/", "_self");
            return;
        }

        if (response.data.authVo != undefined) {
            if (response.data.authVo.userId != undefined) {
                sessionStorage.setItem("remainTime", response.data.authVo.remainTime);
            }
        }
        return response;
    },
    error => {
        return Promise.reject(error);
    },
);

sessionStorage.clear();

//사용자 정보 확인
axios
    .get("/common/auth/info.do", { params: { menuListYn: true } })
    .then((response) => {
        let result = response.data;
        Object.keys(result).forEach((key) => {
            // if(key.startsWith("CODE_"))
            // {
            //     let gbCd = key.split('_')[1];
            //     Vue.prototype.commonCodeList[gbCd] = result[key];
            // }
            // else if(key !== 'authRouteMenuList' && key !== 'authVo')
            // {
            //     sessionStorage.setItem(key, result[key]);
            // }

            if (key !== "authRouteMenuList" && key !== "authVo") {
                sessionStorage.setItem(key, result[key]);
            }

        });

        let routes = [];
        let menuList = result.authRouteMenuList;

        if (menuList === undefined) {
            menuList = [];
        }

        menuList.push({ menuLinkAddress: "/user", vueComponentName: "/user/UserLayout.vue" });
        menuList.push({ menuLinkAddress: "/user/login", vueComponentName: "/user/UserLogin.vue" });
        menuList.push({ menuLinkAddress: "/user/loginsuperuser", vueComponentName: "/user/UserLoginSuperUser.vue" });
        menuList.push({ menuLinkAddress: "/user/agree", vueComponentName: "/user/UserAgree.vue" });
        menuList.push({ menuLinkAddress: "/user/join", vueComponentName: "/user/UserJoin.vue" });

        menuList.push({ menuLinkAddress: "/user/testtt", vueComponentName: "/user/UserInfo.vue" });

        // menuList.push({menuLinkAddress : "/link"})
        // menuList.push({menuLinkAddress : "/link/reference"})

        menuList.push({menuLinkAddress: "/link/reference/", vueComponentName: "/common/notfound.vue"})
        menuList.push({menuLinkAddress: "/link/reference/:discern", vueComponentName: "/applicant/link/ReferenceEdit.vue"})

        menuList.push({ menuLinkAddress: "/", vueComponentName: "/AppRoot.vue" });
        menuList.push({ menuLinkAddress: "*", vueComponentName: "/common/NotFound.vue" });

        // menuList 를 routes 로 변환
        menuList.forEach((value) => {
            let menuLinkAddress = value.menuLinkAddress;
            let vueComponentName = value.vueComponentName;

            let childIndexList = [];
            let pathArray = menuLinkAddress.substring(1).split("/");
            for (let idx = 0; idx < pathArray.length; idx++) {
                let targetRoutes = routes;
                childIndexList.forEach((keyIndex) => {
                    if (targetRoutes[keyIndex].children === undefined) {
                        targetRoutes[keyIndex].children = [];
                    }
                    targetRoutes = targetRoutes[keyIndex].children;
                });

                if (idx < pathArray.length - 1) {
                    // Find the child index
                    let pathName = idx == 0 ? "/" : "";
                    pathName += pathArray[idx];

                    for (let jndex = 0; jndex < targetRoutes.length; jndex++) {
                        if (targetRoutes[jndex].path == pathName) {
                            childIndexList.push(jndex);
                            break;
                        }
                    }
                } else {
                    // Set a value
                    if (targetRoutes.length == 0 && menuLinkAddress.split("/").length > 2) {
                        targetRoutes.push({ path: "/", redirect: menuLinkAddress });
                    }
                    targetRoutes.push({
                        path: menuLinkAddress,
                        component: () => import("@/components" + vueComponentName)
                    });
                }
            }
        });

        router = new VueRouter({
            mode: "history",
            routes,
        });

        router.beforeEach((to, from, next) => {
            // 권한 체크
            let roleCd = sessionStorage.getItem("roleCd");
            let routeNext = true;

            for (let item of Vue.prototype.authRoutes) {
                if (to.path.startsWith(item.path)) {
                    routeNext = false;
                    if ((roleCd != null && item.roleCd.includes(roleCd))) {
                        routeNext = true;
                        break;
                    }
                }
            }

            if (routeNext) {
                next();
            } else if (roleCd != null) {
                alert("현재 로그인한 사용자는 `" + to.path + "`에 접근할 권한이 없습니다.");
                router.push("/");
            } else {
                router.push({
                    path: "/user/login",
                    query: { returnUrl: to.fullPath },
                    replace: true,
                });
            }
        });

        // new Vue({
        //     logger, router, auth, utils, comApplicant, render: (h) => h(App),
        // }).$mount("#app");

        const app = new Vue({
            logger, router, auth, utils, comApplicant, render: (h) => h(App),
        });

        // Vue 2 전역 에러 핸들러
        app.$options.errorHandler = function(err, vm, info) {
            if (err.name === "ChunkLoadError") {
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                return;
            }
            console.error("Vue Error:", err, info);
        };

        app.$mount("#app");
    })
    .catch((error) => {
        console.log(error);
        document.write(
            "<div style='position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center;'>" +
            "<img src='data:image/png;base64,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' alt='KDI로고' style='width: 265px; height: 70px; margin-bottom: 20px;'>" + "<br/>" +
            "<p style='font-size: 24px; color: #666; letter-spacing: -0.7px; margin: 0;'>" + document.title + "</p>" +
            "<p style='font-size: 32px; color: #666; letter-spacing: -1.5px; margin: 8px 0 0 0;'><b style='color: #006334;'>서비스 준비중</b>입니다</p>" +
            "<button onclick=\"window.location.reload()\" style=\"background-color: #006334; color: #fff; padding: 10px 16px; border-radius: 10px; border: none; cursor: pointer; margin-top: 20px; font-size: 16px;\">Retry</button>" +
            "</div>"
        );
    });

export default router;